import { useEffect, useRef } from "react";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { useSelector } from "@jti/store/reduxHooks";

import { scrollToElementWithHeaderCompensation } from "@checkout-v2/shared";
import { useOrderLimit } from "@checkout-v2/shared/hooks/useOrderLimit";
import { formatCheckoutErrorMessage } from "@checkout-v2/shared/utils";

import styles from "./GlobalCheckoutErrorState.module.scss";

export const GlobalCheckoutErrorState = () => {
  const errorElementRef = useRef<HTMLDivElement>(null);
  const error = useSelector((state) => state.checkoutV2.error);
  const { isOrderLimitExceeded, orderLimitMessage } = useOrderLimit();
  const formattedGlobalErrorMessage = formatCheckoutErrorMessage(error?.message);

  useEffect(() => {
    if (!formattedGlobalErrorMessage && !isOrderLimitExceeded) {
      return;
    }
    scrollToElementWithHeaderCompensation(errorElementRef.current);
  }, [formattedGlobalErrorMessage, isOrderLimitExceeded]);

  if (!formattedGlobalErrorMessage && !isOrderLimitExceeded) {
    return null;
  }

  return (
    <div ref={errorElementRef} className={styles.errorBannersWrapper} data-testid="global-checkout-error-state">
      {!!formattedGlobalErrorMessage && (
        <AlertBanner
          data-testid="global-checkout-error-banner"
          tone="error"
          description={formattedGlobalErrorMessage}
        />
      )}
      {isOrderLimitExceeded && (
        <AlertBanner data-testid="global-order-limit-banner" tone="warning" description={orderLimitMessage} />
      )}
    </div>
  );
};
